const PYLON_APP_ID = '4b38f3d6-ca8f-4b74-be57-bf4a7d0dbbf6';
const PYLON_WIDGET_URL = `https://widget.usepylon.com/widget/${PYLON_APP_ID}`;

type PylonQueueFunction = ((cmd: 'show') => void) & {
  q?: unknown[];
  e?: (args: unknown) => void;
};

declare global {
  interface Window {
    Pylon?: PylonQueueFunction;
    pylon?: {
      chat_settings?: {
        app_id?: string;
        email?: string;
        email_hash?: string;
        name?: string;
      };
    };
  }
}

export const setupPylonIdentity = ({
  email,
  emailHash,
  name,
}: {
  email: string;
  emailHash: string;
  name: string | null;
}): void => {
  window.pylon = window.pylon ?? {};
  window.pylon.chat_settings = {
    ...window.pylon.chat_settings,
    app_id: PYLON_APP_ID,
    email,
    email_hash: emailHash,
    name: name ?? undefined,
  };
};

export const ensurePylonWidget = (): void => {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  if (!window.Pylon) {
    const stub: PylonQueueFunction = (...args: unknown[]) => {
      stub.q?.push(args);
    };
    stub.q = [];
    stub.e = (args: unknown) => {
      stub.q?.push(args);
    };
    window.Pylon = stub;
  }

  const hasWidgetScript =
    document.querySelector(`script[src="${PYLON_WIDGET_URL}"]`) !== null;

  if (hasWidgetScript) {
    return;
  }

  const script = document.createElement('script');
  script.setAttribute('type', 'text/javascript');
  script.setAttribute('async', 'true');
  script.setAttribute('src', PYLON_WIDGET_URL);
  document.body.appendChild(script);
};
